import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { RequestConfirmationComponent } from './request-confirmation.component';
var RequestConfirmationDirective = /** @class */ (function () {
    function RequestConfirmationDirective(_dialogService) {
        this._dialogService = _dialogService;
        this._enabled = true;
    }
    Object.defineProperty(RequestConfirmationDirective.prototype, "requestConfirmation", {
        set: function (enabled) {
            this._enabled = enabled || enabled === undefined;
        },
        enumerable: true,
        configurable: true
    });
    RequestConfirmationDirective.prototype._onClick = function () {
        if (this._enabled) {
            this._dialogService.open(RequestConfirmationComponent);
        }
    };
    return RequestConfirmationDirective;
}());
export { RequestConfirmationDirective };
